import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["category", "children"];
import React, { memo } from 'react';
import PropTypes from 'prop-types';
var LargeButton = function LargeButton(props) {
  var category = props.category,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: "btn btn-".concat(category, " btn-block btn-rounded text-uppercase")
  }, rest), children);
};
LargeButton.defaultProps = {
  category: 'primary'
};
LargeButton.propTypes = {
  category: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default /*#__PURE__*/memo(LargeButton);